export default __webpack_public_path__ + "89c4faf671bb79d3d516470540451307.webp";